import { Component } from '@angular/core';
import { BaseSimpleListViewDirective } from '@app/shared/base-views/base-simple-list-view.directive';
import { PaymentTemplateEventsService } from '@app/logic/payment-template-events/payment-template-events.service';
import { IPaymentTemplateEventDto } from '@classictechsolutions/hubapi-transpiled-enums';
import { CbEnumService } from '@app/core/services/enum/enum.service';
import { PermissionsPermissions } from '@app/core/permissions';
import { CbDialogService } from '@app/shared/components/dialog/cb-dialog.service';
import { PaymentTemplateEventsMapped } from '@app/logic/payment-template-events/payment-template-events.mapped';
import { IPaymentTemplateEventsMapped } from '@app/logic/payment-template-events/interfaces/i.payment-template-events.mapped';
import { take } from 'rxjs';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { PaymentTemplateEventsDialogComponent } from '@app/views/settings/pages/payment-template-events/components/payment-template-events-dialog.component';

@Component({
    selector: 'cb-payment-template-events',
    templateUrl: './payment-template-events.component.html',
    providers: [PaymentTemplateEventsService],
    standalone: false
})
export class PaymentTemplateEventsComponent extends BaseSimpleListViewDirective<
    IPaymentTemplateEventDto,
    PaymentTemplateEventsService
> {
    public readonly displayedColumns: string[] = ['code', 'label', 'active', 'actions'];
    public searchResults: IPaymentTemplateEventsMapped[] = [];
    public sortOrderChanged = false;

    constructor(
        public readonly enumService: CbEnumService,
        public readonly permissionsPermissions: PermissionsPermissions,
        public readonly dialog: CbDialogService,
        private readonly paymentTemplateEventsService: PaymentTemplateEventsService
    ) {
        super(
            dialog,
            paymentTemplateEventsService,
            PaymentTemplateEventsDialogComponent,
            'Payment Template Event',
            PaymentTemplateEventsMapped,
            permissionsPermissions
        );
    }

    public drop(event: CdkDragDrop<IPaymentTemplateEventsMapped[]>): void {
        if (event.previousIndex !== event.currentIndex) {
            moveItemInArray(this.searchResults, event.previousIndex, event.currentIndex);
            this.searchResults = [...this.searchResults];
            this.sortOrderChanged = true;
        }
    }

    public saveOrder(): void {
        this.dialog.confirm({
            message: 'Are you sure you want to save the order of the Payment Template Events?',
            confirmed: this.handleSaveOrder
        });
    }

    private readonly handleSaveOrder = (): void => {
        this.paymentTemplateEventsService
            .saveSortOrder(this.searchResults)
            .pipe(take(1))
            .subscribe(result => {
                this.searchResults = result;
                this.sortOrderChanged = false;
            });
    };
}
